export const triggerDownload = (doc) => {
  const a = document.createElement('a');
  a.href = doc.downloadUrl;
  a.download = `${doc.classificationData.document.metadata.ean}.zip`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => {
    window.URL.revokeObjectURL(doc.downloadUrl);
  }, 5000);
};
